import Link from 'next/link';
import React from 'react';

import { AmbaImagePropsType } from '@/models/globalModels';

import ConditionalWrapper from './ConditionalWrapper';

const AmbaImage = ({ imageSrc, fallbackSrc, alt = '', extraClass = '', isLink = false, targetUrl }: AmbaImagePropsType) => {
  const [mainImageSrc, setMainImageSrc] = React.useState<string | undefined>('');

  const switchDefaultImage = () => {
    setMainImageSrc(fallbackSrc);
  };

  React.useEffect(() => {
    setMainImageSrc(imageSrc);
  }, [imageSrc]);

  return (
    <div>
      <ConditionalWrapper
        condition={isLink}
        wrapper={
          (children: React.ReactNode) => <Link href={targetUrl as string}>{children}</Link> //only renders if its a linked image
        }
      >
        <picture>
          <source srcSet={mainImageSrc} type="image/webp" />
          <source srcSet={mainImageSrc} type="image/jpeg" />
          <img alt={alt} className={`mx-auto d-block ${extraClass}`} onError={() => switchDefaultImage()} srcSet={mainImageSrc} />
        </picture>
      </ConditionalWrapper>
    </div>
  );
};

export default AmbaImage;
